import { render, staticRenderFns } from "./pkqPaper.vue?vue&type=template&id=029da5da&scoped=true"
import script from "./pkqPaper.vue?vue&type=script&lang=js"
export * from "./pkqPaper.vue?vue&type=script&lang=js"
import style0 from "./pkqPaper.vue?vue&type=style&index=0&id=029da5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029da5da",
  null
  
)

export default component.exports